import script from "./Requisition.vue?vue&type=script&setup=true&lang=js"
export * from "./Requisition.vue?vue&type=script&setup=true&lang=js"

import "./Requisition.vue?vue&type=style&index=0&id=40c728ab&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c728ab"]])

export default __exports__